
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const CriteriasModule = {
  namespaced: true,
  strict: true,
  state: {
    approved_companies_criterias: {},
    unapproved_companies_criterias: {},
    is_approved_companies: {},
  },
  getters,
  actions,
  mutations
};

export default CriteriasModule;
